import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PARTNER_SCOPED,
  URL_PUBLIC,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/routing'

// Warehouse-less, partner + site scoped (mirrors cart-assistant): the site is chosen in-tool via
// the scope picker, so the URL carries `/sites/:storeConfigId` but no `/warehouses/:warehouse_id`.
// The parent route puts `storeConfigId` into the router match; the child route's scope wrapper reads
// it via useParams. Registered in the domain's `partnerScoped` router bucket.
const URL_SEO = `${URL_PARTNER_SCOPED}/seo${URL_SITE_SCOPED}`
// The SEO settings editor lives at a dedicated `/seo-settings` sub-path so its URL stays stable as
// sibling SEO pages (sitemap, meta defaults) land alongside it. Its first section is robots.txt.
const URL_SEO_SETTINGS = `${URL_SEO}/seo-settings`
// @hygen:inject scoped-urls

/*
 * Admin routes — marketplace-only (no `:storeConfigId`); registered in the `admin` router bucket.
 */
const URL_ADMIN_SEO = `${URL_APP_ADMIN}/seo`
const URL_ADMIN_SEO_SETTINGS = `${URL_ADMIN_SEO}/seo-settings`

export type DashRouteSet =
  | DashRouteType<'seo'>
  | DashRouteType<'seo-settings'>
  // Admin routes
  | DashRouteType<'app-admin-seo'>
  | DashRouteType<'app-admin-seo-settings'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  seo: URL_SEO,
  'seo-settings': URL_SEO_SETTINGS,
  // @hygen:inject route-pair

  // Admin routes
  'app-admin-seo': URL_ADMIN_SEO,
  'app-admin-seo-settings': URL_ADMIN_SEO_SETTINGS,
}

export type DomainRouteName = keyof typeof routes
